module.exports = __webpack_public_path__ + "static/img/ch12.fad24ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ch12.png
// module id = 4M50
// module chunks = 73